import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'
import MenuProperty from './MenuProperty'
export default MenuProperty.extend({
  components: {VueSlider},
  computed: {
    device() {
      return this.$store.getters['pageModule/device']
    },
    elementContent() {
      return this.$store.getters[`${this.module}/content`](this.element, this.parentModule)
    },
    elementStyles() {
      return this.$store.getters[`${this.module}/styles`](this.element, 'styles', this.parentModule)
    },
    elementAssets() {
      return this.$store.getters[`${this.module}/assets`](this.element, this.parentModule)
    },
  }
})